import { useQuery } from '@tanstack/react-query';
import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import type { RdModalityAgeBands } from '@/services/quotes/rd-equipamentos/types';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';

/**
 * Faixas de agravação por idade por modalidade (`GET .../config/age-bands`).
 * Cadastro de produto — muda raramente, mesmo `staleTime` das demais facetas
 * de configuração RD.
 */
export function useRdAgeBands() {
  return useQuery<RdModalityAgeBands>({
    queryKey: ['rd-age-bands'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getAgeBands();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao buscar faixas de agravação por idade'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
